import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW2700Model } from './kymw2700.model';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { FlexGrid } from '@grapecity/wijmo.grid';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { CheckAllPageService } from './api-services/check-all-page.service';
import { CheckBaseKomaPublishingService } from './api-services/check-base-koma-publishing.service';
import { CopyBasePageService } from './api-services/copy-base-page.service';
import { GetCatalogPageProgressService } from './api-services/get-catalog-page-progress.service';
import { GetCatalogPhaseInfoService } from './api-services/get-catalog-phase-info.service';
import { InitFixationPhaseComboService } from './api-services/init-fixation-phase-combo.service';
import { PhaseFixationService } from './api-services/phase-fixation.service';
import { KYMW2700GetCatalogPageProgressModel } from './vo/kymw2700-get-catalog-page-progress.model';
import { KYMW2700CopyBasePageModel } from './vo/kymw2700-copy-base-page.model';
import { KYMW2700PhaseFixationModel } from './vo/kymw2700-phase-fixation.model';
import { KYMW0D00InputModel } from '../../../commons/kymw0d/kymw0d00/vo/kymw0d00-input.model';
import { KYMW0D00Component } from '../../../commons/kymw0d/kymw0d00/kymw0d00.component';
import { OutputPagenationListModel } from '../../kymw25/kymw2500/vo/output-pagenation-list.model';
import { OutputPagenationListService } from '../../kymw25/kymw2500/api-services/output-pagenation-list.service';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { CatalogLockService } from '../../../commons/kymw00/api-services/catalog-lock.service';
import { VMediumTypeComboBoxComponent } from '../../../commons/kymw02/combo-box/vmedium-type-combo-box/vmedium-type-combo-box.component';
import { RadioLabelComponent } from 'src/app/commons/kymw02/radio-label/radio-label.component';
import { CanDeactivateType } from 'src/app/shared/utils/leave-confirm.guard';


/**
 * 基版コピー・フェーズ管理画面を管理するクラス
 *
 * @export KYMW2700Component
 * @class KYMW2700Component
 */
@Component({
  selector: 'app-kymw2700',
  templateUrl: 'kymw2700.component.html',
  styleUrls: ['kymw2700.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW2700Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  @ViewChild('txt_OrderCode', { static: true }) txt_OrderCode: OrderCodeTextInputComponent;
  @ViewChild('dtg_KihanCopyList', { static: true }) dtg_KihanCopyList: FlexGrid;
  @ViewChild('cmb_FixationPhase', { static: true }) cmb_FixationPhase: ElementRef;
  @ViewChild('btn_CheckAllPage', { static: true }) btn_CheckAllPage: ElementRef;
  @ViewChild('chk_FixationLockRelease', { static: true }) chk_FixationLockRelease: ElementRef;
  @ViewChild('btn_Fixation', { static: true }) btn_Fixation: ElementRef;
  @ViewChild('btn_outputPagenation', { static: true }) btn_outputPagenation: ElementRef;
  @ViewChild('btn_CheckKihanPage', { static: true }) btn_CheckKihanPage: ElementRef;
  @ViewChild('btn_AllCopySelectedKihan', {static: true}) btn_AllCopySelectedKihan: ElementRef;
  @ViewChild('cmb_MediumType', { static: true }) cmb_MediumType: VMediumTypeComboBoxComponent;
  @ViewChild('rdb_KihanCopy', {static: true} ) rdb_KihanCopy: RadioLabelComponent;
  @ViewChild('all_Kihancopy_Check', { static:true }) all_Kihancopy_Check: ElementRef;
  @ViewChild('chk_PhaseSkipLockRelease', { static: true }) chk_PhaseSkipLockRelease :ElementRef;

  public kymw2700Model: KYMW2700Model = new KYMW2700Model();

  /**
   * Creates an instance of KYMW2700Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW2700Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private catalogLockServiceSub: CatalogLockService,

    private outputPagenationListService: OutputPagenationListService,
    private checkAllPageService: CheckAllPageService,
    private checkBaseKomaPublishingService: CheckBaseKomaPublishingService,
    private copyBasePageService: CopyBasePageService,
    private getCatalogPageProgressService: GetCatalogPageProgressService,
    private getCatalogPhaseInfoService: GetCatalogPhaseInfoService,
    private initFixationPhaseComboService: InitFixationPhaseComboService,
    private phaseFixationService: PhaseFixationService,
    private fileDownloadConfirmService: FileDownloadConfirmService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW2700Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW2700';
    this.catalogLockService = this.catalogLockServiceSub;

    // 05. 確定フェーズコンボボックス情報取得API呼び出し
    this.initFixationPhaseComboService.execute(this.kymw2700Model,
      (data: any) => this.initFixationPhaseComboServiceSuccessFunc(data));

    setTimeout(() => {
      this.plessEnabledSetting();
    });

    this.dtg_KihanCopyList.itemsSourceChanged.addHandler(() => {
      this.dtg_KihanCopyList.select(-1, -1);
    });

    // 表示モードを基版コピーに設定
    this.kymw2700Model.rdb_DisplayMode = '1';
    this.eventDisplayMode_CHANGEHandler();

    // 閲覧ユーザー時 活性制御
    if ( this.getFuncPermission() === this.kymw00Model.FUNC_PERMISSION_READONLY ){
      this.kymw2700Model.cmbFixationPhaseDisabled = true;
      this.kymw2700Model.chkAllKihanCopyDisabled = true;
      this.kymw2700Model.chkKihanCopyDisabled = true;
      this.plessEnabled(this.btn_CheckKihanPage, false);
      this.plessEnabled(this.btn_AllCopySelectedKihan, false);
      this.plessEnabled(this.btn_CheckAllPage, false);
      this.plessEnabled(this.chk_FixationLockRelease, false);
      this.plessEnabled(this.chk_PhaseSkipLockRelease, false);
    }

    // セルクリックでチェックボックス選択
    this.dtg_KihanCopyList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = this.dtg_KihanCopyList.hitTest(e);
      if ((0 <= ht.row) && (3 == ht.col)) {
        if (!ht.target.className.includes('header-checkbox') && !ht.target.className.includes('all-kihancopy-checkbox')) {
          document.getElementById(`cb_select_kihancopy_${ht.row}`).click();
        }
      }
    });
  }

  /**
   * ngOnInit内で設定するplessEnabledの処理を記述するメソッド
   *
   * @memberof KYMW2300Component
   */
  public plessEnabledSetting() {
    // 画面部品の活性・非活性制御処理
    // 「確定」ボタン非活性化
    this.plessEnabled(this.btn_Fixation, false);
    this.plessEnabled(this.cmb_FixationPhase, false);

    // 「全頁チェック」ボタン非活性化
    this.plessEnabled(this.btn_CheckAllPage, false);

    // 「ページネーション情報出力」ボタン非活性化
    this.plessEnabled(this.btn_outputPagenation, false);

    // 確定ボタンロック解除非活性化、チェックOFF
    this.updateChkFixationLockMode(false);

    this.plessEnabled(this.chk_FixationLockRelease, false);

    // 活性フラグ制御
    this.kymw2700Model.dtgKihanCopyListEditable = false;                        // 基版コピーグリッド編集可能フラグ
    this.plessEnabled(this.btn_CheckAllPage, false);                            // 全ページチェックボタン活性フラグ
    this.plessEnabled(this.btn_Fixation, false);                                // 確定ボタン活性フラグ

    this.rdb_KihanCopy.setFocus();
  }

  /**
   * 受注コード変更時イベント処理
   *
   * @memberof KYMW2700Component
   */
  public eventOrderCodeCHANGEHandler(): void {
    // フルコントロールの場合
    if ( this.getFuncPermission() === this.kymw00Model.FUNC_PERMISSION_FULLCONTROL ) {
      // 活性・非活性制御処理
      this.plessEnabled(this.btn_Fixation, false);
      this.plessEnabled(this.cmb_FixationPhase, true);
      this.plessEnabled(this.btn_CheckAllPage, false);
    }

    // 確定ボタンロック解除非活性化、チェックOFF
    this.updateChkFixationLockMode(false);

    // 媒体をクリア
    this.kymw2700Model.mediumType = '';

    // 現在フェーズデータ更新処理
    this.kymw2700Model.updateKihanCopyListAndPhaseByNull();

    this.cmb_FixationPhase.nativeElement.selectedIndex = 0;

    // 受注コードの妥当性チェック
    if (this.txt_OrderCode.isValidOrderCode()) {
      // 企画ロック処理(解除)
      this.LockUtilForCatalog('RELEASE',
        this.kymw2700Model.lockedOrderCode, this.kymw2700Model.lockedMidiumTypeCode,
        null, null,
        null, null,
        false,
        false);
    }
  }

  /**
   * 媒体コンボ変更時イベント処理
   *
   * @memberof KYMW2700Component
   */
  public eventMediumTypeCHANGEHandler(): void {
    // 活性・非活性制御処理
    this.plessEnabled(this.btn_Fixation, false);
    this.plessEnabled(this.btn_CheckAllPage, false);

    // 確定ボタンロック解除非活性化、チェックOFF
    this.updateChkFixationLockMode(false);

    // 現在フェーズデータ更新処理
    this.kymw2700Model.updateKihanCopyListAndPhaseByNull();

    this.cmb_FixationPhase.nativeElement.selectedIndex = 0;

    // 企画ロック処理(解除)
    this.LockUtilForCatalog('RELEASE',
      this.kymw2700Model.lockedOrderCode, this.kymw2700Model.lockedMidiumTypeCode,
      null, null,
      null, null,
      false,
      false);
  }

  /**
   * 表示ボタン押下イベント処理
   *
   * @returns {void}
   * @memberof KYMW2700Component
   */
  public eventBtnDisplayCLICKHandler(): void {
    this.kymw2700Model.lockedResultFlag = '';

    // 配達企画回(翌週)のチェック
    if (!this.txt_OrderCode.isValidOrderCode()) {
      this.dialogService.openAlertGetMessage('E0113', ['入力した受注コード']);
      return;
    }
    // 媒体区分のチェック
    if (PlessViewUtilsSub.isEmpty(this.kymw2700Model.mediumType)) {
      this.dialogService.openAlertGetMessage('E0103', ['媒体']);
      return;
    }

    // 権限のチェック
    if (this.getFuncPermission() === this.kymw00Model.FUNC_PERMISSION_FULLCONTROL) {  // 「2：フルコントロール可能」の場合
      // 企画ロック処理
      // 成功時、基版コピー一覧表示を行う。
      this.LockUtilForCatalog('REGIST_WITH_FORCE_RELEASE',
        this.kymw2700Model.orderCode, this.kymw2700Model.mediumType,
        (successParam: any) => {
          this.lockOkFunc(successParam);
        }, null,
        (faultParam: any) => {
          this.lockErrFunc(faultParam);
        }, null,
        false,
        false);
    }

    // ロック処理結果に問わず、フェーズ表示を行う。
    this.getCatalogPhaseInfo();

    // 基版コピー一覧表示処理
    this.getCatalogPageProgress();

    // 編集ロック処理条件を保持しておく(解除時のため)
    this.kymw2700Model.lockedOrderCode = this.kymw2700Model.orderCode;
    this.kymw2700Model.lockedMidiumTypeCode = this.kymw2700Model.mediumType;
  }

  /**
   * 基版コピー処理
   *
   * @returns {void}
   * @memberof KYMW2700Component
   */
  public batchBigining(): void {
    this.kymw2700Model.cntLimit = this.kymw2700Model.kihanCopyCheckedList.length;
    this.kymw2700Model.carrot = Number(0);

    for (; this.kymw2700Model.carrot < this.kymw2700Model.cntLimit; this.kymw2700Model.carrot++) {
      break;
    }

    if (this.kymw2700Model.carrot >= this.kymw2700Model.cntLimit) {
      return;
    }

    const targetRowObject: any = this.kymw2700Model.kihanCopyCheckedList[this.kymw2700Model.carrot];

    const copyBasePageVO: KYMW2700CopyBasePageModel = new KYMW2700CopyBasePageModel();
    copyBasePageVO.orderCode = targetRowObject.OrderCode;
    copyBasePageVO.mediumType = targetRowObject.MediumType;
    copyBasePageVO.coopCode = targetRowObject.DiverFromCoopCode;
    copyBasePageVO.pageNum = targetRowObject.PageNum;

    // 自動コマ配置ステータスのチェック
    if (targetRowObject.AutoArrangeStatus === '1') {                         // 基版コピー先に自動コマ配置済みの生協が含まれている場合
      // 確認メッセージを表示する。(%1が存在します、処理を継続しますか？)
      this.dialogService.openAlertGetMessage('Q0143', ['自動コマ配置済みのページ・生協情報'],
        (closeEvent: number) => {
          if (closeEvent === PlessAlert.Yes) {
            // 基版コピー処理(自動コマ配置実施確認フラグ：確認済)
            this.batchBiginingCopyBasePage(copyBasePageVO, '1');
          }
        });
    } else {
      // 基版コピー処理(自動コマ配置実施確認フラグ：未確認)
      this.batchBiginingCopyBasePage(copyBasePageVO, '0');
    }
  }

  /**
   * 基版コピー処理（API呼び出し）
   *
   * @param {KYMW2700CopyBasePageModel} reqVO
   * @param {string} flag
   * @memberof KYMW2700Component
   */
  public batchBiginingCopyBasePage(reqVO: KYMW2700CopyBasePageModel, flag: string): void {
    // 自動コマ配置実施確認フラグを初期化
    reqVO.confirmFlag = flag;

    // 02. 基版コピーAPI呼び出し
    this.copyBasePageService.execute(this.kymw2700Model, reqVO,
      (data: any) => this.batchBiginingCopyBasePageServiceSuccessFunc(data, reqVO));
  }

  /**
   * 基版ページチェックボタン押下イベント処理
   *
   * @returns {void}
   * @memberof KYMW2700Component
   */
  public eventBtnCheckKihanPageCLICKHandler(): void {
    // 配達企画回(翌週)のチェック
    if (!this.txt_OrderCode.isValidOrderCode()) {
      this.dialogService.openAlertGetMessage('E0113', ['入力した受注コード']);
      return;
    }
    // 媒体区分のチェック
    if (PlessViewUtilsSub.isEmpty(this.kymw2700Model.mediumType)) {
      this.dialogService.openAlertGetMessage('E0103', ['媒体']);
      return;
    }

    // 04. 基版ページチェックAPIリクエストVO初期化処理
    const reqVO: KYMW2700CopyBasePageModel = new KYMW2700CopyBasePageModel();
    reqVO.orderCode = this.kymw2700Model.orderCode;
    reqVO.mediumType = this.kymw2700Model.mediumType;

    // 04. 基版ページチェックAPI呼び出し
    this.checkBaseKomaPublishingService.execute(this.kymw2700Model, reqVO,
      (data: any) => this.checkBaseKomaPublishingServiceSuccessFunc(data));
  }

  /**
   * 確定フェーズコンボ変更時イベント処理
   *
   * @memberof KYMW2700Component
   */
  public eventFixationPhaseCHANGEHandler(): void {
    this.plessEnabled(this.btn_Fixation, false);

    // 確定ボタンロック解除非活性化、チェックOFF
    this.updateChkFixationLockMode(false);

    if (PlessViewUtilsSub.isEmpty(this.kymw2700Model.progressWorkNum)) {
      this.plessEnabled(this.btn_CheckAllPage, false);
    } else {
      this.plessEnabled(this.btn_CheckAllPage, true);
    }
  }

  /**
   * 全ページチェックボタン押下イベント処理
   *
   * @returns {void}
   * @memberof KYMW2700Component
   */
  public eventBtnCheckAllPageCLICKHandler(): void {
    // 配達企画回(翌週)のチェック
    if (!this.txt_OrderCode.isValidOrderCode()) {
      this.dialogService.openAlertGetMessage('E0113', ['入力した受注コード']);
      return;
    }
    // 媒体区分のチェック
    if (PlessViewUtilsSub.isEmpty(this.kymw2700Model.mediumType)) {
      this.dialogService.openAlertGetMessage('E0103', ['媒体']);
      return;
    }
    // 確定フェーズコードのチェック
    if (PlessViewUtilsSub.isEmpty(this.kymw2700Model.progressWorkNum)) {
      this.dialogService.openAlertGetMessage('E0113', ['選択した確定フェーズ']);
      return;
    }

    // 全ページチェック押下時点の確定ボタンロック解除のチェック状態を保持しておく。

    // 03. 全ページチェックAPIリクエストVO初期化処理
    const reqVO: KYMW2700PhaseFixationModel = new KYMW2700PhaseFixationModel();
    reqVO.orderCode = this.kymw2700Model.orderCode;
    reqVO.mediumType = this.kymw2700Model.mediumType;
    reqVO.phaseCode = this.kymw2700Model.progressWorkNum;

    // 03. 全ページチェックAPI呼び出し
    this.checkAllPageService.execute(this.kymw2700Model, reqVO,
      (data: any) => this.checkAllPageServiceSuccessFunc(data));
  }

  /**
   * 確定ボタンロック解除チェックボックス変更イベント処理
   *
   * @memberof KYMW2700Component
   */
  public eventFixationLockCHANGEHandler(): void {
    // 確定ボタンロック解除のチェック
    if (this.kymw2700Model.chkFixationLockSelectedMode) {                       // ONの場合
      // 確定ボタン活性化
      this.plessEnabled(this.btn_Fixation, true);
    } else {                                                                    // OFFの場合
      // 確定ボタン非活性化
      this.plessEnabled(this.btn_Fixation, false);
    }
  }

  /**
   * 確定ボタン押下イベント処理
   *
   * @returns {void}
   * @memberof KYMW2700Component
   */
  public eventBtnFixationCLICKHandler(): void {
    // 配達企画回(翌週)のチェック
    if (!this.txt_OrderCode.isValidOrderCode()) {
      this.dialogService.openAlertGetMessage('E0113', ['入力した受注コード']);
      return;
    }
    // 媒体区分のチェック
    if (PlessViewUtilsSub.isEmpty(this.kymw2700Model.mediumType)) {
      this.dialogService.openAlertGetMessage('E0103', ['媒体']);
      return;
    }
    // 確定フェーズコードのチェック
    if (PlessViewUtilsSub.isEmpty(this.kymw2700Model.progressWorkNum)) {
      this.dialogService.openAlertGetMessage('E0113', ['選択した確定フェーズ']);
      return;
    }

    // 企画ロック処理
    // 成功時、フェーズ確定処理を行う。
    this.LockUtilForCatalog('REGIST_WITH_FORCE_RELEASE',
      this.kymw2700Model.orderCode, this.kymw2700Model.mediumType,
      (successParam: any) => {
        this.kymw2700Model.isFirstFlg = true;
        this.executePhaseFixation(successParam);
      }, null,
      null, null,
      false,
      false);

    // 編集ロック処理条件を保持しておく(解除時のため)
    this.kymw2700Model.lockedOrderCode = this.kymw2700Model.orderCode;
    this.kymw2700Model.lockedMidiumTypeCode = this.kymw2700Model.mediumType;
  }

  /**
   * ページネーション情報出力ボタン押下イベント処理
   *
   * @returns {void}
   * @memberof KYMW2700Component
   */
  public eventBtnOutputCLICKHandler(): void {
    // 配達企画回(翌週)のチェック
    if (!this.txt_OrderCode.isValidOrderCode()) {
      this.dialogService.openAlertGetMessage('E0113', ['入力した受注コード']);
      return;
    }
    // 媒体区分のチェック
    if (PlessViewUtilsSub.isEmpty(this.kymw2700Model.mediumType)) {
      this.dialogService.openAlertGetMessage('E0103', ['媒体']);
      return;
    }

    // ページネーション情報出力APIリクエストVO初期化処理
    const reqVO: OutputPagenationListModel = new OutputPagenationListModel();
    reqVO.OutputDiv = '2';                                                      // 出力区分(2:基版コピー・フェーズ管理画面)
    reqVO.OrderCode = this.kymw2700Model.orderCode;                             // 受注コード
    reqVO.MediumType = this.kymw2700Model.mediumType;                           // 媒体区分

    // ページネーション情報出力API呼び出し
    this.outputPagenationListService.execute(null, reqVO,
      (data: any) => {
        // ファイル名の設定
        const fileName = 'ページネーション情報.xls';

        // ファイルダウンロード
        this.fileDownloadConfirmService.show(data.FileName, fileName);
      });
  }

  // ロック処理 START
  /**
   * ロック取得成功時
   *
   * @private
   * @param {*} successParam
   * @memberof KYMW2700Component
   */
  private lockOkFunc(successParam: any): void {
    // 活性・非活性制御処理
    this.plessEnabled(this.cmb_FixationPhase, true);
    this.plessEnabled(this.btn_outputPagenation, true);
    if ( this.getFuncPermission() !== this.kymw00Model.FUNC_PERMISSION_READONLY ) {
      this.plessEnabled(this.btn_AllCopySelectedKihan, true);
    }

    this.kymw2700Model.dtgKihanCopyListEditable = true;

    this.kymw2700Model.lockedResultFlag = 'true';
  }

  /**
   * ロック取得失敗時
   *
   * @private
   * @param {*} faultParam
   * @memberof KYMW2700Component
   */
  private lockErrFunc(faultParam: any): void {
    // 活性・非活性制御処理
    this.plessEnabled(this.cmb_FixationPhase, false);
    this.plessEnabled(this.btn_outputPagenation, false);
    this.plessEnabled(this.btn_AllCopySelectedKihan, false);

    this.kymw2700Model.dtgKihanCopyListEditable = false;

    this.kymw2700Model.lockedResultFlag = 'false';

    this.dialogService.openAlertGetMessage('E0207', ['指定した受注コード', '「コマ割」「商品企画メンテナンス」で編集中', '基版コピー']);
  }

  /**
   * フェーズ確定処理
   *
   * @private
   * @memberof KYMW2700Component
   */
  private executePhaseFixation(successParam: any): void {
    // 07. フェーズ確定APIリクエストVO初期化処理
    const reqVO: KYMW2700PhaseFixationModel = new KYMW2700PhaseFixationModel();
    reqVO.orderCode = this.kymw2700Model.orderCode;
    reqVO.mediumType = this.kymw2700Model.mediumType;
    reqVO.phaseCode = this.kymw2700Model.progressWorkNum;
    reqVO.forcedPhaseFixationFlag = this.kymw2700Model.forcedPhaseFixationFlag;
    reqVO.commitDataBaseFlag = this.kymw2700Model.commitDataBaseFlag;
    reqVO.phaseSkipFlag = this.kymw2700Model.chkPhaseSkipLockFlag;
    reqVO.isFirstFlg = this.kymw2700Model.isFirstFlg;

    // 07. フェーズ確定API呼び出し
    this.phaseFixationService.execute(this.kymw2700Model, reqVO, (data: any) => {
      this.phaseFixationServiceSuccessFunc(data);
      this.cmb_MediumType.reload(this.kymw2700Model.orderCode);
      this.cmb_MediumType.setMediumType(this.kymw2700Model.mediumType);
    });
  }

  // ロック処理 END

  // API SuccessFunc START

  /**
   * 01. 基版コピー情報取得API成功処理
   *
   * @param {*} data APIレスポンス
   * @memberof KYMW2700Component
   */
  public getCatalogPageProgressServiceSuccessFunc(data: any): void {
    this.kymw2700Model.updateCopyList(data);
  }

  /**
   * 02. 基版コピーAPI成功処理
   *
   * @param {*} data APIレスポンス
   * @memberof KYMW2700Component
   */
  public batchBiginingCopyBasePageServiceSuccessFunc(data: any, reqVO: KYMW2700CopyBasePageModel): void {
    // 自動コマ配置実施確認要否フラグのチェック
    if (data.AutoArrangeConfirmFlag === '1') {                                  // 「1：確認必要」の場合
      // 確認メッセージを表示する。(%1が存在します、処理を継続しますか？)
      this.dialogService.openAlertGetMessage('Q0143', ['自動コマ配置済みのページ・生協情報'],
        (closeEvent: number) => {
          if (closeEvent === PlessAlert.Yes) {
            this.batchBiginingCopyBasePage(reqVO, '1');
          }
        });
    } else {                                                                    // 「1：確認必要」以外の場合
      // 確定ボタンロック解除制御処理(チェック状態をOFF)
      this.updateChkFixationLockMode(false);

      let tempDataList: Array<any> = new Array<any>();

      if (data !== null) {
        tempDataList = data.KihanCopyList;

        if (PlessViewUtilsSub.isEmptyArray(tempDataList)) {
          tempDataList = new Array<any>();
        }
      }

      this.kymw2700Model.updateKihanCopyList(tempDataList);

      this.kymw2700Model.carrot = this.kymw2700Model.carrot + 1;

      if (this.kymw2700Model.carrot < this.kymw2700Model.cntLimit) {
        this.batchBigining();
      }

      // グリッドの再描画
      this.dtg_KihanCopyList.editableCollectionView.refresh();

      this.kymw2700Model.allKihanCopyCheck = false;
    }
  }

  /**
   * 03. 全ページチェックAPI成功処理
   *
   * @param {*} data APIレスポンス
   * @memberof KYMW2700Component
   */
  public checkAllPageServiceSuccessFunc(data: any): void {
    const vo: KYMW0D00InputModel = new KYMW0D00InputModel();
    vo.dispId = 'KYMW2700';
    vo.dataDiv = '1';

    // 「処理ログ」画面を呼び出す
    this.displayProcessLog(vo);

    // 機能権限、処理結果のチェック
    if (this.getFuncPermission() === this.kymw00Model.FUNC_PERMISSION_FULLCONTROL                              // 「2：フルコントロール可能」、
      && (data.Code === '-2' || data.RequireParamCheckCode === '-2' || data.MediumAdminResultCode === '-2')) { // 「-2:エラー」の場合
      // // 確定ボタンロック解除制御(非活性)
      // this.updateChkFixationLockMode(false);

      // 確定ボタンロック解除制御（活性）
      // ※全ページチェックの結果に関わらず確定ボタンを常に活性化（ロック解除）する制御とする。
      // 今後修正が入る可能性あり
      this.kymw2700Model.chkFixationLockSelectedMode = false;  // 確定ボタンのロック解除をOFF
      this.updateChkFixationLockMode(true);   // 確定ボタンロック解除制御
    } else {                                                                                                   // 上記以外の場合
      // 確定ボタンロック解除制御(活性)
      this.updateChkFixationLockMode(true);
    }
  }

  /**
   * 04. 基版ページチェックAPI成功処理
   *
   * @param {*} data APIレスポンス
   * @memberof KYMW2700Component
   */
  public checkBaseKomaPublishingServiceSuccessFunc(data: any): void {
    const vo: KYMW0D00InputModel = new KYMW0D00InputModel();
    vo.dispId = 'KYMW2700';
    vo.dataDiv = '1';

    // 「処理ログ」画面を呼び出す
    this.displayProcessLog(vo);
  }

  /**
   * 05. 確定フェーズコンボボックス情報取得API成功処理
   *
   * @param {*} data APIレスポンス
   * @memberof KYMW2700Component
   */
  public initFixationPhaseComboServiceSuccessFunc(data: any): void {
    // 確定フェーズコンボボックスデータ更新処理
    this.kymw2700Model.initFixationPhaseCombo(data);
  }

  /**
   * 06. 現在フェーズ情報取得API成功処理
   *
   * @param {*} data APIレスポンス
   * @memberof KYMW2700Component
   */
  public getCatalogPhaseInfoServiceSuccessFunc(data: any): void {
    this.kymw2700Model.updateKihanPhase(data);
  }

  /**
   * 07. フェーズ確定API成功処理
   *
   * @param {*} data APIレスポンス
   * @memberof KYMW2700Component
   */
  public phaseFixationServiceSuccessFunc(data: any): void {
    this.kymw2700Model.isFirstFlg = data.IsFirstFlg.toLowerCase() === 'true';
    if (data.CommitDataBaseFlag === 'CommitDataBase') {
      this.kymw2700Model.commitDataBaseFlag = true;
      this.executePhaseFixation(null);
    } else {
      this.kymw2700Model.commitDataBaseFlag = false;
    }

    // 媒体区分がハピデリの場合、他媒体も選択したフェーズと同一かを判断する。
    if (data.AllMediumSamePhaseFlag === 'NotSamePhase') {
      // 確認メッセージ表示
      this.dialogService.openAlertGetMessage('Q0137', null,
        (closeEvent: number) => {
          if (closeEvent === PlessAlert.Yes) {
            this.kymw2700Model.forcedPhaseFixationFlag = true;
            this.executePhaseFixation(null);
          } else {
            this.updateChkFixationLockMode(true);
          }
        });
    } else {
      if (this.kymw2700Model.commitDataBaseFlag === false) {
        // 確定処理成功の場合
        this.kymw2700Model.forcedPhaseFixationFlag = false;
      }

      // CWSデータ作成で異常がある場合は処理ログを表示する
      if (data.CwsErrorFlag === 'true') {
        const vo: KYMW0D00InputModel = new KYMW0D00InputModel();
        vo.dispId = 'KYMW2700';
        vo.dataDiv = '2';
        // 「処理ログ」画面を呼び出す
        this.displayProcessLog(vo);
      }

      this.updateChkFixationLockMode(false);
    }
  }

  /**
   * 08. ページネーション情報出力API成功処理
   *
   * @param {*} data APIレスポンス
   * @memberof KYMW2700Component
   */
  public outputPagenationListServiceSuccessFunc(data: any): void {
  }

  // API SuccessFunc END

  /**
   * 確定ボタンロック解除制御処理
   *
   * @param {boolean} value
   * @memberof KYMW2700Component
   */
  public updateChkFixationLockMode(value: boolean): void {
    this.kymw2700Model.chkFixationLockEnableMode = value;

    // 確定ボタンロック解除が活性化の場合かつ、確定ボタンロック解除チェック状態がONの場合
    if (value && this.kymw2700Model.chkFixationLockSelectedMode) {
      // 確定ボタンロック解除のチェック状態をONにする
      this.kymw2700Model.chkFixationLockSelectedMode = true;
      this.plessEnabled(this.btn_Fixation, true);
    } else {
      // 確定ボタンロック解除のチェック状態をOFFにする
      this.kymw2700Model.chkFixationLockSelectedMode = false;
      this.plessEnabled(this.btn_Fixation, false);
    }
  }

  /**
   * 基版コピー一覧表示処理
   *
   * @memberof KYMW2700Component
   */
  public getCatalogPageProgress(): void {
    // 01. 基版コピー情報取得APIリクエストVO初期化処理
    const reqVO: KYMW2700GetCatalogPageProgressModel = new KYMW2700GetCatalogPageProgressModel();
    reqVO.orderCode = this.kymw2700Model.orderCode;
    reqVO.mediumType = this.kymw2700Model.mediumType;

    // 01. 基版コピー情報取得API呼び出し
    this.getCatalogPageProgressService.execute(this.kymw2700Model, reqVO,
      (data: any) => this.getCatalogPageProgressServiceSuccessFunc(data));
  }

  /**
   * 現在フェーズ表示処理
   *
   * @private
   * @memberof KYMW2700Component
   */
  private getCatalogPhaseInfo(): void {
    // 06. 現在フェーズ情報取得APIリクエストVO初期化処理
    const reqVO: KYMW2700GetCatalogPageProgressModel = new KYMW2700GetCatalogPageProgressModel();
    reqVO.orderCode = this.kymw2700Model.orderCode;
    reqVO.mediumType = this.kymw2700Model.mediumType;

    // 06. 現在フェーズ情報取得API呼び出し
    this.getCatalogPhaseInfoService.execute(this.kymw2700Model, reqVO,
      (data: any) => this.getCatalogPhaseInfoServiceSuccessFunc(data));
  }

  /**
   * 処理ログ表示
   *
   * @param {KYMW0D00InputModel} vo
   * @memberof KYMW2700Component
   */
  public displayProcessLog(vo: KYMW0D00InputModel): void {
    // 処理ログ登録画面の呼び出し
    const componentRef = this.dialogService.openModal(KYMW0D00Component);
    const instance = componentRef.componentInstance as KYMW0D00Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 表示モード切り替え
   * 
   */
  public eventDisplayMode_CHANGEHandler():void {
    const kihanButtons = document.getElementById('kihan-buttons');
    const phaseContentDiv = document.getElementById('phase-content');
    // 基版コピー
    if (this.kymw2700Model.rdb_DisplayMode === "1") {
      kihanButtons.style.display = 'flex';
      phaseContentDiv.style.display = 'none';
    } else if(this.kymw2700Model.rdb_DisplayMode === "2") {
      // フェーズ管理
      kihanButtons.style.display = 'none';
      phaseContentDiv.style.display = 'block';
    }
  }

  /**
   * 選択基版を一括コピーボタン押下時
   * 
   */
  public exentBtnSelectedKihanCopyClickHandler() {
    this.kymw2700Model.kihanCopyCheckedList = new Array<any>();

    // 基版コピーリストのチェック
    for (let i = Number(0); i < this.kymw2700Model.kihanCopyList.length; i++) {
      const data = this.kymw2700Model.kihanCopyList[i];
      if ( data.isChecked ) {
        this.kymw2700Model.kihanCopyCheckedList.push(data); 
      }
    }
    if (PlessViewUtilsSub.isEmptyArray(this.kymw2700Model.kihanCopyCheckedList)) {
      this.dialogService.openAlert('コピー対象のページを選択してください', 'E');
      return;
    }
    
    this.dialogService.openAlertGetMessage('Q0179', [], (closeEvent: any) => {
      if (closeEvent === PlessAlert.Yes) {
        this.dialogService.openAlertGetMessage('Q0180', [], (closeEvent: any) => {
          if (closeEvent === PlessAlert.Yes) {
            // 自動コマ配置実施確認フラグを初期化
            this.kymw2700Model.confirmFlag = '0';                                       // 「0：未確認」

            // 基版コピー処理
            this.batchBigining();
          }
        });
      }
    });
  }

  /**
   * ヘッダー「基版コピー」チェックボックスクリック 一括選択
   * 
   */
  public eventKihanCopyAllCheck_CLICKHandler(): void {
    if( this.kymw2700Model.kihanCopyList != null) {
      if (this.kymw2700Model.allKihanCopyCheck) {
        for(let i = Number(0); i < this.kymw2700Model.kihanCopyList.length; i++) {
          const tempList = this.kymw2700Model.kihanCopyList[i];
          tempList.isChecked = true;
        }
        this.kymw2700Model.allKihanCopyCheck = true;
      } else {
        for(let i = Number(0); i < this.kymw2700Model.kihanCopyList.length; i++) {
          const tempList = this.kymw2700Model.kihanCopyList[i];
          tempList.isChecked = false;
        }
        this.kymw2700Model.allKihanCopyCheck = false;
      }
    }
  }

  /**
   * グローバルメニュー操作による画面離脱時
   */
  canDeactivate(): CanDeactivateType {
    // 企画ロック処理(解除)
    this.LockUtilForCatalog('RELEASE',
      this.kymw2700Model.lockedOrderCode, this.kymw2700Model.lockedMidiumTypeCode,
      null, null, null, null, false, false
    );
    return true;
  }
}
